import React from "react";

import svg from "../../assets/images/icons/expression.svg";

export const ExpressionIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Expression"}
    />
);
